import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clientPortalService } from '@leoclinic/services';
import type { Client } from '@leoclinic/types';

const CLIENT_PORTAL_KEY = ['client-portal'] as const;

export function useMyClient() {
  return useQuery<Client | null>({
    queryKey: [...CLIENT_PORTAL_KEY, 'client'],
    queryFn: () => clientPortalService.getMyClientRecord(),
    staleTime: 60 * 1000,
  });
}

export function useMyAppointments() {
  return useQuery({
    queryKey: [...CLIENT_PORTAL_KEY, 'appointments'],
    queryFn: () => clientPortalService.listMyAppointments(),
    staleTime: 30 * 1000,
  });
}

export function useClientPortalMutations() {
  const queryClient = useQueryClient();

  const cancelMutation = useMutation({
    mutationFn: (appointmentId: string) => clientPortalService.cancelMyAppointment(appointmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENT_PORTAL_KEY });
    },
  });

  const linkProfileMutation = useMutation({
    mutationFn: () => clientPortalService.linkProfile(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENT_PORTAL_KEY });
    },
  });

  return {
    cancelAppointment: cancelMutation.mutateAsync,
    linkProfile: linkProfileMutation.mutateAsync,
    isCancelling: cancelMutation.isPending,
  };
}

export { CLIENT_PORTAL_KEY };
